module.exports = __webpack_public_path__ + "media/images/badge-ac3a2474b13ad7905d66661796738d67.png";